import i18n from 'i18next';
import {
  CreateAssetSchema,
  CreateRampAssetSchema,
  UpdateAssetSchema,
  UpdateRampAssetSchema,
} from 'pos-shared/models/assetSchema.ts';
import { z } from 'zod';

const alphanumericRegex = /^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/;

export const CreateAssetRefinedSchema = CreateAssetSchema.extend({
  reference: z
    .string()
    .regex(alphanumericRegex, {
      error: i18n.t('common.formErrors.alphaNumericOnly'),
    })
    .optional(),
}).superRefine((data, ctx) => {
  if (
    data.assetTypeName?.toLowerCase() === 'ramp' &&
    !alphanumericRegex.test(data.name)
  ) {
    ctx.addIssue({
      code: 'custom',
      path: ['name'],
      message: i18n.t('common.formErrors.alphaNumericOnly'),
    });
  }
});

export const CreateRampAssetRefinedSchema = CreateRampAssetSchema.extend({
  reference: z
    .string()
    .regex(alphanumericRegex, {
      error: i18n.t('common.formErrors.alphaNumericOnly'),
    })
    .optional(),
}).superRefine((data, ctx) => {
  if (
    data.assetTypeName?.toLowerCase() === 'ramp' &&
    !alphanumericRegex.test(data.name)
  ) {
    ctx.addIssue({
      code: 'custom',
      path: ['name'],
      message: i18n.t('common.formErrors.alphaNumericOnly'),
    });
  }
});

export const UpdateAssetRefinedSchema = UpdateAssetSchema.extend({
  reference: z
    .string()
    .regex(alphanumericRegex, {
      error: i18n.t('common.formErrors.alphaNumericOnly'),
    })
    .optional(),
}).superRefine((data, ctx) => {
  if (
    data.assetTypeName?.toLowerCase() === 'ramp' &&
    !alphanumericRegex.test(data.name)
  ) {
    ctx.addIssue({
      code: 'custom',
      path: ['name'],
      message: i18n.t('common.formErrors.alphaNumericOnly'),
    });
  }
});

export const UpdateRampAssetRefinedSchema = UpdateRampAssetSchema.extend({
  reference: z
    .string()
    .regex(alphanumericRegex, {
      error: i18n.t('common.formErrors.alphaNumericOnly'),
    })
    .optional(),
}).superRefine((data, ctx) => {
  if (
    data.assetTypeName?.toLowerCase() === 'ramp' &&
    !alphanumericRegex.test(data.name)
  ) {
    ctx.addIssue({
      code: 'custom',
      path: ['name'],
      message: i18n.t('common.formErrors.alphaNumericOnly'),
    });
  }
});

export type CreateAssetRefinedModel = z.infer<typeof CreateAssetRefinedSchema>;
export type CreateRampAssetRefinedModel = z.infer<
  typeof CreateRampAssetRefinedSchema
>;
export type UpdateAssetRefinedModel = z.infer<typeof UpdateAssetRefinedSchema>;
export type UpdateRampAssetRefinedModel = z.infer<
  typeof UpdateRampAssetRefinedSchema
>;
